/*
 * cart-discount-tiers.js — animation de la barre de paliers.
 *
 * Le tiroir panier est entièrement re-rendu à chaque modification : la barre
 * réapparaît directement à sa nouvelle largeur, sans transition. On mémorise
 * donc la valeur précédente, on repositionne la barre dessus, puis on laisse
 * la transition CSS jouer vers la nouvelle valeur.
 */
(function () {
  'use strict';

  // Le tiroir est rendu sur toutes les pages : une seule initialisation.
  if (window.__cartTiersReady) return;
  window.__cartTiersReady = true;

  var PCT_KEY = 'helvia_cart_tiers_pct';
  var REACHED_KEY = 'helvia_cart_tiers_reached';

  function read(key) {
    try {
      var v = parseFloat(sessionStorage.getItem(key));
      return isNaN(v) ? null : v;
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      sessionStorage.setItem(key, String(value));
    } catch (e) {
      /* navigation privée */
    }
  }

  function animate() {
    var fill = document.querySelector('.cart-tiers__fill');

    // Panier vide ou barre masquée : on repart de zéro au prochain ajout.
    if (!fill) {
      write(PCT_KEY, 0);
      write(REACHED_KEY, 0);
      return;
    }

    // Un re-rendu recrée l'élément : le marqueur disparaît avec lui.
    if (fill.dataset.tiersAnimated === 'true') return;
    fill.dataset.tiersAnimated = 'true';

    var target = parseFloat(fill.style.width);
    if (isNaN(target)) return;

    var dots = Array.prototype.slice.call(document.querySelectorAll('.cart-tiers__dot'));
    var labels = Array.prototype.slice.call(document.querySelectorAll('.cart-tiers__step'));
    var reached = dots.filter(function (d) { return d.classList.contains('is-reached'); }).length;

    var prevPct = read(PCT_KEY);
    var prevReached = read(REACHED_KEY);

    if (prevPct !== null && prevPct !== target) {
      var dotsAndLabels = dots.concat(labels);
      var animateSteps = prevReached !== null && prevReached !== reached;

      // 1. On repose la barre sur l'ancienne valeur, transition coupée.
      fill.style.transition = 'none';
      fill.style.width = prevPct + '%';

      // Les pastilles et libellés franchis reprennent leur état précédent,
      // pour que leur couleur change en même temps que la barre les atteint.
      if (animateSteps) {
        dotsAndLabels.forEach(function (node) {
          if (node.classList.contains('is-reached')) {
            node.dataset.tiersRestore = 'true';
            node.classList.remove('is-reached');
          }
        });
      }

      // 2. Force le navigateur à appliquer cet état avant la suite.
      void fill.offsetWidth;

      // 3. Tâche suivante : on réactive la transition et on vise la nouvelle
      //    valeur. Volontairement sur setTimeout et non requestAnimationFrame,
      //    qui est gelé quand l'onglet n'est pas au premier plan.
      setTimeout(function () {
        fill.style.transition = '';
        fill.style.width = target + '%';

        if (!animateSteps) return;
        setTimeout(function () {
          dotsAndLabels.forEach(function (node) {
            if (node.dataset.tiersRestore === 'true') {
              delete node.dataset.tiersRestore;
              node.classList.add('is-reached');
            }
          });
        }, 220);
      }, 30);
    }

    write(PCT_KEY, target);
    write(REACHED_KEY, reached);
  }

  function watch() {
    var target = document.getElementById('CartDrawer') || document.body;
    var timer = null;
    var observer = new MutationObserver(function () {
      // Un re-rendu déclenche plusieurs mutations d'affilée.
      clearTimeout(timer);
      timer = setTimeout(animate, 60);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  function init() {
    animate();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
